<div class="emeni-popup" [class]="data.type ? 'emeni-popup emeni-popup--' + data.type : 'emeni-popup'">
  <button
    *ngIf="data.showCloseButton"
    type="button"
    class="emeni-popup__close"
    (click)="cancel()"
    [attr.aria-label]="closeLabel"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div *ngIf="data.type" class="emeni-popup__icon">
    <mat-icon>{{ iconName }}</mat-icon>
  </div>

  <h2 *ngIf="data.title" class="emeni-popup__title">{{ data.title }}</h2>

  <p
    *ngIf="data.text"
    class="emeni-popup__text"
    [class.emeni-popup__text--left]="data.bodyAlign === 'left'"
  >{{ data.text }}</p>
  <div
    *ngIf="data.html"
    class="emeni-popup__text"
    [class.emeni-popup__text--left]="data.bodyAlign === 'left'"
    [innerHTML]="data.html"
  ></div>

  <input
    *ngIf="data.input"
    class="emeni-popup__input"
    type="text"
    [attr.inputmode]="data.inputMode || null"
    [placeholder]="data.inputPlaceholder || ''"
    [(ngModel)]="value"
    (keyup.enter)="confirm()"
    autocomplete="off"
  />

  <label *ngIf="data.checkbox" class="emeni-popup__checkbox">
    <input type="checkbox" [(ngModel)]="checkboxValue" />
    <span>{{ data.checkboxLabel }}</span>
  </label>

  <div class="emeni-popup__actions">
    <button
      *ngIf="showCancel"
      type="button"
      class="alertbtn alertbtn--secondary"
      (click)="cancel()"
    >
      {{ cancelText }}
    </button>
    <button
      *ngIf="showDeny"
      type="button"
      class="alertbtn alertbtn--danger"
      (click)="deny()"
    >
      {{ denyText }}
    </button>
    <button
      *ngIf="showConfirm"
      type="button"
      class="alertbtn alertbtn--primary"
      (click)="confirm()"
    >
      {{ confirmText }}
    </button>
  </div>
</div>
